import React, { FC } from 'react';
import { Card } from 'antd';
import { useTranslate } from '@/translations';
import { PageContainer, Title } from '@/ui/components';
import { faTruckFast } from '@fortawesome/free-solid-svg-icons';
import { TransportUnitsDataGrid } from './components/TransportUnitsDataGrid/TransportUnitsDataGrid';

export const AdminTransportUnits: FC = () => {
  const { t } = useTranslate();
  return (
    <PageContainer>
      <Title title={t('manageTransportUnits')} icon={faTruckFast} />

      <Card>
        <TransportUnitsDataGrid />
      </Card>
    </PageContainer>
  );
};
